import Parse from 'parse/dist/parse.min.js';

/**
 * Every non-deleted Client row belonging to the same person as
 * `clientId`.
 *
 * A client who is in several groups is one person with one `uuid` and
 * one Client row per group, so anything scoped to a client has to be
 * scoped to all of them. Nine store plugins open-coded these two
 * queries; this is that code once, with the guard they were all
 * missing. `response[0].attributes.uuid` on an empty result threw a
 * TypeError that aborted the rest of createSubscription() silently,
 * which is what a client deleted by somebody else used to look like:
 * no subscription, stale data, no error anywhere.
 *
 * Returns undefined, not [], when the client is gone. The callers
 * feed the result to containedIn("client", ...), and containedIn on an
 * empty array is a valid query that matches nothing, so returning []
 * would quietly open a subscription that can never fire, which is the
 * silence this exists to end. undefined forces the caller to decide.
 *
 * Kept as two round trips rather than one matchesKeyInQuery so the
 * existing "issues two Client queries" assertion in the plugin test
 * harness keeps its meaning. Collapsing them is a separate change.
 */
export async function queryClientTwins(clientId) {
	if (!clientId) { return undefined }

	const clientQuery = new Parse.Query('Client');
	clientQuery.equalTo("objectId", clientId);
	clientQuery.notEqualTo("deleted", true);
	const found = await clientQuery.find();
	if (found.length === 0) { return undefined }

	// A legacy row without a uuid would otherwise match every other
	// row that has none.
	const uuid = found[0].attributes.uuid;
	if (!uuid) { return found }

	const twinQuery = new Parse.Query('Client');
	twinQuery.equalTo("uuid", uuid);
	twinQuery.notEqualTo("deleted", true);
	return twinQuery.find();
}
